import { Review } from "@core/domain/models/review.model";
import { IncidentMetadata } from "@core/domain/models/reviewItemMetadata/incidentMetadata";
import { BuiltInImportSourceId } from "@core/domain/types/builtInImportSourceId";
import { ReviewItemType } from "@core/domain/types/reviewItemType.type";
import axios from "axios";

interface DateFilter {
  startDate?: string;
  endDate?: string;
}

export class MaudeApiClient {
  async createReviewSearch(
    review: Review,
    query: string,
  ): Promise<{
    query?: string;
    filters?: string;
    date: string;
    reviewId: number;
    importSourceId: string;
    items: IncidentMetadata & { type: ReviewItemType.Incident }[];
    queryTranslation?: string;
    url?: string;
  }> {
    const result = await this.simpleSearch(query);
    return {
      query,
      date: new Date().toISOString(),
      reviewId: review.id,
      importSourceId: BuiltInImportSourceId.MAUDE,
      items: result.map((a) => ({
        ...a,
        type: ReviewItemType.Incident,
      })),
    };
  }

  async simpleSearch(query: string): Promise<IncidentMetadata[]> {
    let incidents: IncidentMetadata[] = [];
    const url = "/live-scraper/maude-simple-search";
    try {
      const response = await axios.post(url + `?query=${query}`);
      incidents = response.data;
    } catch (error) {
      console.error("Error fetching records from MAUDE API:", error);
      throw error;
    }

    return incidents;
  }

  async search({
    deviceName,
    manufacturer,
    dateFilter,
  }: {
    deviceName?: string;
    manufacturer?: string;
    dateFilter?: DateFilter;
  }): Promise<IncidentMetadata[]> {
    return this.advancedSearch(deviceName, manufacturer, dateFilter);
  }
  private async advancedSearch(
    deviceName?: string,
    manufacturer?: string,
    dateFilter?: DateFilter,
  ): Promise<IncidentMetadata[]> {
    let incidents: IncidentMetadata[] = [];
    const url = "/live-scraper/maude-advanced-search";
    try {
      const params = new URLSearchParams();
      if (deviceName) params.append("deviceName", deviceName);
      if (manufacturer) params.append("manufacturer", manufacturer);
      if (dateFilter?.startDate) params.append("startDate", dateFilter.startDate);
      if (dateFilter?.endDate) params.append("endDate", dateFilter.endDate);

      const response = await axios.post(url + (params.toString() ? "?" + params.toString() : ""));
      incidents = response.data;
    } catch (error) {
      console.error("Error fetching records from MAUDE API:", error);
      throw error;
    }

    return incidents;
  }
}
